export default [
    {
        path: '/reservations',
        name: 'reservations',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Reservations/Reservations.vue')
    }
]